export const facilities = [
  { name: "みどり苑 本館", url: "#facility" },
  { name: "みどり苑 南館", url: "#facility" },
  { name: "みどり苑 東館", url: "#facility" },
  { name: "ケアホーム さくら", url: "#facility" },
  { name: "デイサービス はな", url: "#facility" },
  { name: "グループホーム つばき", url: "#facility" },
  { name: "訪問介護センター あおば", url: "#facility" },
  { name: "地域包括支援センター みどり", url: "#facility" },
];

export const services = [
  { name: "特別養護老人ホーム", url: "#service" },
  { name: "ショートステイ", url: "#service" },
  { name: "デイサービス", url: "#service" },
  { name: "ホームヘルパー", url: "#service" },
  { name: "訪問看護", url: "#service" },
  { name: "グループホーム", url: "#service" },
  { name: "居宅介護支援", url: "#service" },
  { name: "地域包括支援センター", url: "#service" },
];

export const importantCards = [
  {
    number: "01",
    label: "Space",
    title: "居場所",
    image1: "https://readdy.ai/api/search-image?query=elderly%20care%20facility%20bright%20clean%20comfortable%20room%20with%20natural%20light%20plants%20and%20warm%20interior%20design&width=400&height=400&seq=imp01&orientation=squarish",
    points: [
      "つねに清潔で快適な環境を整える",
      "一人ひとりと目を合わせ、笑顔で話す",
      "生き生きと過ごせる空間をつくる",
    ],
  },
  {
    number: "02",
    label: "Fact",
    title: "事実",
    image1: "https://readdy.ai/api/search-image?query=caregiver%20nurse%20attentively%20listening%20to%20elderly%20patient%20taking%20notes%20with%20care%20and%20compassion%20in%20bright%20room&width=400&height=400&seq=imp02&orientation=squarish",
    points: [
      "ご利用者の現実から逃げずに受け止める",
      "身体の変化や言葉を記録して活かす",
      "ご家族・チームに状況を共有する",
    ],
  },
  {
    number: "03",
    label: "Life",
    title: "命",
    image1: "https://readdy.ai/api/search-image?query=warm%20caring%20moment%20between%20elderly%20person%20and%20caregiver%20holding%20hands%20smiling%20together%20in%20sunlit%20garden&width=400&height=400&seq=imp03&orientation=squarish",
    points: [
      "思いやりを持ち、最期まで寄り添う",
      "体調の変化に気づき、迅速に対応する",
      "笑顔があふれる健やかな生活を支援する",
    ],
  },
];

export const galleryImages = [
  "https://readdy.ai/api/search-image?query=modern%20Japanese%20elderly%20care%20facility%20interior%20spacious%20bright%20common%20room%20with%20large%20windows%20green%20plants%20and%20comfortable%20seating&width=1200&height=675&seq=gal01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=professional%20caregiver%20staff%20smiling%20helping%20elderly%20residents%20in%20a%20clean%20well-lit%20care%20home%20dining%20area%20Japan&width=1200&height=675&seq=gal02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=beautiful%20Japanese%20care%20facility%20garden%20courtyard%20with%20seasonal%20flowers%20elderly%20residents%20enjoying%20outdoor%20activities%20sunshine&width=1200&height=675&seq=gal03&orientation=landscape",
];

export const kvImages = [
  "https://readdy.ai/api/search-image?query=warm%20sunlit%20Japanese%20elderly%20care%20facility%20hallway%20with%20caregiver%20and%20elderly%20resident%20walking%20together%20smiling%20natural%20light&width=1920&height=1080&seq=kv01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=professional%20Japanese%20care%20home%20staff%20team%20smiling%20together%20in%20bright%20modern%20facility%20green%20plants%20white%20walls&width=1920&height=1080&seq=kv02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=elderly%20Japanese%20woman%20enjoying%20afternoon%20tea%20in%20beautiful%20care%20facility%20garden%20surrounded%20by%20flowers%20and%20greenery&width=1920&height=1080&seq=kv03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=caregiver%20gently%20assisting%20elderly%20man%20with%20rehabilitation%20exercises%20in%20bright%20modern%20Japanese%20care%20facility%20room&width=1920&height=1080&seq=kv04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=group%20of%20elderly%20residents%20and%20caregivers%20doing%20gentle%20exercise%20activity%20together%20in%20spacious%20bright%20Japanese%20care%20home&width=1920&height=1080&seq=kv05&orientation=landscape",
];

export const recruitImages = [
  "https://readdy.ai/api/search-image?query=young%20Japanese%20female%20caregiver%20smiling%20warmly%20in%20care%20facility%20uniform%20white%20background%20professional%20portrait&width=600&height=800&seq=rec01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Japanese%20male%20care%20worker%20helping%20elderly%20resident%20with%20daily%20activities%20in%20bright%20modern%20facility%20cheerful%20atmosphere&width=600&height=800&seq=rec02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Japanese%20female%20nurse%20caregiver%20in%20scrubs%20smiling%20confidently%20in%20care%20home%20corridor%20natural%20light%20professional&width=600&height=800&seq=rec03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=team%20of%20Japanese%20care%20facility%20staff%20in%20uniform%20smiling%20together%20group%20photo%20bright%20modern%20building%20exterior&width=600&height=800&seq=rec04&orientation=portrait",
];
